import React, { memo, useEffect, useState } from 'react'
import type { CustomCellEditorProps } from 'ag-grid-react'
import AccountSelect from '../../../../../features/account/components/AccountSelect'
import './SelectCellEditor.css'

interface AccountSelectCellEditorParams {
  balanceSheetRowIds?: number[]
  selectableBalanceSheetRowId?: number
  allowClear?: boolean
}

const AccountSelectCellEditor = memo(
  ({
    value,
    onValueChange,
    stopEditing,
    cellStartedEdit,
    balanceSheetRowIds,
    selectableBalanceSheetRowId,
    allowClear = true
  }: CustomCellEditorProps<any, number> & AccountSelectCellEditorParams) => {
    const [isReady, setIsReady] = useState(false)

    useEffect(() => {
      setTimeout(() => {
        setIsReady(true)
      }, 0)
    }, [])

    const handleChange = (newValue: number | undefined) => {
      onValueChange(newValue)
      if (cellStartedEdit) {
        setTimeout(() => {
          stopEditing()
        }, 0)
      }
    }

    if (!isReady) return null

    return (
      <AccountSelect
        value={value ?? undefined}
        onChange={handleChange}
        balanceSheetRowIds={balanceSheetRowIds}
        selectableBalanceSheetRowId={selectableBalanceSheetRowId}
        allowClear={allowClear}
        style={{ width: '100%' }}
      />
    )
  }
)

AccountSelectCellEditor.displayName = 'AccountSelectCellEditor'

export default AccountSelectCellEditor
